import React from 'react';
import { CheckmarkIcon } from '../../icons';
var MuiCheckbox = {
    /* put your new default props here */
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true,
    icon: React.createElement(React.Fragment, null),
    checkedIcon: React.createElement(CheckmarkIcon, { color: "inherit", fontSize: "inherit" }),
    inputProps: {},
};
export default MuiCheckbox;
//# sourceMappingURL=MuiCheckbox.js.map